module.exports = __webpack_public_path__ + "img/adSearch_checked.45dd2079.svg";